import styled from 'styled-components'

/* O estado da campanha é contexto, não o assunto da coluna: sai como texto
   secundário para não disputar atenção com a pílula do status do anúncio. */
export const CampaignState = styled.small`
  display: block;
  margin-top: var(--sl-space-1);
  font: var(--sl-text-caption-2-font);
  letter-spacing: var(--sl-text-caption-2-letter-spacing);
  color: var(--sl-fg-base-soft);
`
